/*=========================================================================================
  File Name: moduleAuthActions.js
  Description: Auth Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../axios'

export default {
  getAgreements ({ commit, state }) {
    if (state.agreements.length > 0) return
    return new Promise((resolve, reject) => {
      axios.get('/ez/agreements')
        .then(response => {
          commit('ADD_AGREEMENTS', response.data.data)
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },

  createAgreement ({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.post('/ez/agreements', payload)
        .then(response => {
          commit('ADD_AGREEMENTS', [response.data.data])
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },

  updateAgreement ({commit}, payload) {
    return new Promise((resolve, reject) => {
      axios.patch(`/ez/agreements/${payload.uuid}`, payload.update)
        .then(response => {
          commit('DELETE_AGREEMENT', [response.data.data.uuid])
          commit('ADD_AGREEMENTS', [response.data.data])
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },

  deleteAgreement ({commit}, uuid) {
    return new Promise((resolve, reject) => {
      axios.delete(`/ez/agreements/${uuid}`)
        .then(response => {
          commit('DELETE_AGREEMENT', [uuid])
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },

  // get register agreements list (Unauthenticated)

  getRegisterFormAgreements ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/agreements/register')
        .then(response => {
          commit('SET_REGISTER_AGREEMENTS', response.data.data)
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },

  // get register agreements list (Admin)

  getRegisterAgreements ({ commit, state }) {
    if (state.registerAgreements.length > 0) return
    return new Promise((resolve, reject) => {
      axios.get('/cp/agreements/register')
        .then(response => {
          commit('SET_REGISTER_AGREEMENTS', response.data.data)
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  },

  // set agreements as register

  setRegisterAgreements ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.patch('/cp/agreements/register', payload)
        .then(response => {
          commit('SET_AGREEMENTS_AS_REGISTER', response.data.data)
          resolve(response)
        })
        .catch(error => { reject(error) })
    })
  }

 
}
